import { render } from "./WhatWeDo.vue?vue&type=template&id=14da3916&scoped=true"
import script from "./WhatWeDo.vue?vue&type=script&lang=js"
export * from "./WhatWeDo.vue?vue&type=script&lang=js"

import "./WhatWeDo.vue?vue&type=style&index=0&id=14da3916&scoped=true&lang=css"

import exportComponent from "/vercel/path0/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-14da3916"]])

export default __exports__